import homePage from './homePage/actions'


export default {
  homePage,
}
